/**
 * Action types
 */

import { createTypes } from 'reduxsauce'
import { IComponentState, IPaginator, ISearch } from '../root.types'
import { FollowUp } from '../../application/models/followUp/followUp'

export const FollowUpTypes = createTypes(`

    HANDLE_STEPPER
    HANDLE_STEPPER_TWO

    LOAD_FOLLOWUP_SUCCESS
    LOAD_FOLLOWUP_FAILURE 
    LOAD_FOLLOWUP_REQUEST

    CREATE_FOLLOWUP_REQUEST
    CREATE_FOLLOWUP_SUCCESS
    CREATE_FOLLOWUP_FAILURE

    FIND_FOLLOWUP_SUCCESS
    FIND_FOLLOWUP_FAILURE 
    FIND_FOLLOWUP_REQUEST

    UPDATE_FOLLOWUP_REQUEST
    UPDATE_FOLLOWUP_SUCCESS
    UPDATE_FOLLOWUP_FAILURE
    
`,
    {
        prefix: '@followUp/'
    }
)

/**
 * State type
 */
export interface IFollowUpState {
    readonly list: IListState
    readonly create: ICreateState
    readonly stepper: number
    readonly stepperTwo: number
}
export interface IListState extends IComponentState {
    readonly followUps: FollowUp[]
    readonly paginator: IPaginator
}
export interface ICreateState extends IComponentState {
    readonly followUp: FollowUp
}
export interface IActionLoad {
    readonly paginator?: IPaginator
    readonly patientId: string
    readonly filter?: ISearch
}
export interface IActionFind {
    readonly patientId: string
    readonly followUpId: string
}
export interface IActionUpdate {
    readonly followUp: FollowUp
}
export interface IActionCreate {
    readonly patientId: string
}
